// Logic.tsx
import * as Yup from "yup"
import {
     CONST_CANDIDAT_REMUNERATION_SOUHAITE_FORMAT__BRUT,
     CONST_CANDIDAT_REMUNERATION_SOUHAITE_JOUR_OR_MOIS_OR_ANNEE__ANNEE,
     CONST_DISPONIBILITE_DATE_EXACTE,
     CONST_MIME_APPLICATION_DOC,
     CONST_MIME_APPLICATION_DOCX,
     CONST_MIME_APPLICATION_GOOGLE_DOC,
     CONST_MIME_APPLICATION_PDF,
     CONST_MIME_IMAGE_JPEG,
     CONST_MIME_IMAGE_JPG,
     CONST_MIME_IMAGE_PNG,
     CONST_MOBILITE_DEPARTEMENTAL,
     CONST_MOBILITE_PAR_VILLE,
     CONST_MOBILITE_REGIONAL,
} from "@common-constants/*"

export interface IFormValuesModel {
     createSuiviSansTemplateOuAvecTemplate: string | "AVEC_TEMPLATE" | "SANS_TEMPLATE"
     template?: number
     notes?: string
     disponibilite?: string
     disponibiliteDate?: string
     mobilite?: string
     mobiliteRegions?: number[]
     mobiliteDepartements?: number[]
     mobiliteVilles?: number[]
     remunerationSouhaiteMontant?: number
     voulezVousJoindreUnDocumentToThisSuivi: boolean
     remunerationSouhaiteFormat?: string
     remunerationSouhaiteJournalierOuMensuelOuAnnuel?: string // Corrected typo from previous model
     remunerationSouhaiteJourOrMensuelOrAnnuel?: string
     document?: File
     feeling?: string
     feelingCommentaire?: string
     annonce?: number // Added for context
     candidatType: string // Added for validation context
}

export const initialValues: IFormValuesModel = {
     createSuiviSansTemplateOuAvecTemplate: "SANS_TEMPLATE",
     voulezVousJoindreUnDocumentToThisSuivi: false,
     remunerationSouhaiteFormat: CONST_CANDIDAT_REMUNERATION_SOUHAITE_FORMAT__BRUT,
     remunerationSouhaiteJourOrMensuelOrAnnuel: CONST_CANDIDAT_REMUNERATION_SOUHAITE_JOUR_OR_MOIS_OR_ANNEE__ANNEE,
     notes: "",
     feeling: "",
     feelingCommentaire: "",
     candidatType: "",
}

export const EntretienTelValidationSchema = Yup.object().shape({
     createSuiviSansTemplateOuAvecTemplate: Yup.string().label(`"Type de suivi"`).required(),
     template: Yup.number()
          .label(`"Template"`)
          .when("createSuiviSansTemplateOuAvecTemplate", {
               is: "AVEC_TEMPLATE",
               then: schema => schema.required(),
          }),
     annonce: Yup.number(),
     notes: Yup.string().label(`"Notes"`),
     // ... rest of schema remains identical
     disponibilite: Yup.string().label(`"Disponibilité"`),
     disponibiliteDate: Yup.string()
          .when("disponibilite", {
               is: CONST_DISPONIBILITE_DATE_EXACTE,
               then: schema => schema.required(),
          })
          .label(`"Date de disponibilité"`),
     mobilite: Yup.string().nullable().label(`"Mobilité"`),
     mobiliteRegions: Yup.array()
          .when("mobilite", {
               is: CONST_MOBILITE_REGIONAL,
               then: schema => schema.required(),
          })
          .label(`"Régions"`),
     mobiliteDepartements: Yup.array()
          .when("mobilite", {
               is: CONST_MOBILITE_DEPARTEMENTAL,
               then: schema => schema.required(),
          })
          .label(`"Départements"`),
     mobiliteVilles: Yup.array()
          .when("mobilite", {
               is: CONST_MOBILITE_PAR_VILLE,
               then: schema => schema.required(),
          })
          .label(`"Villes"`),
     remunerationSouhaiteMontant: Yup.number().label("Rémunération souhaité"),
     remunerationSouhaiteFormat: Yup.string().label("Rémunération brut ou net"),
     remunerationSouhaiteJourOrMensuelOrAnnuel: Yup.string().label("Rémunération jour / mois / année"),
     voulezVousJoindreUnDocumentToThisSuivi: Yup.boolean(),
     document: Yup.mixed()
          .when("voulezVousJoindreUnDocumentToThisSuivi", {
               is: true,
               then: schema => schema.required(),
          })
          .test("fileFormat", "Seuls les formats word / PDF / image sont acceptés", (value: any) => {
               if (!value) return true
               return [
                    CONST_MIME_IMAGE_JPEG,
                    CONST_MIME_IMAGE_JPG,
                    CONST_MIME_APPLICATION_PDF,
                    CONST_MIME_IMAGE_PNG,
                    CONST_MIME_APPLICATION_DOCX,
                    CONST_MIME_APPLICATION_DOC,
                    CONST_MIME_APPLICATION_GOOGLE_DOC,
               ].includes(value.type)
          })
          .test("fileSize", "Le document ne doit pas dépasser 10MB", (value: any) => {
               if (!value) return true
               return value.size <= 10 * 1024 * 1024
          })
          .label(`"Document"`),
     feeling: Yup.string().nullable().label(`"Feeling"`),
     feelingCommentaire: Yup.string().nullable().label(`"Commentaire de feeling"`),
})
